import Icon from '@xo-union/tk-component-icons';
import React, { ReactNode } from 'react';
import { IconName } from '@xo-union/dist-iconography';
import { Grabber } from './Grabber';
import styles from './item.scss';

export interface ItemProps {
  children: any;
  onClick?: any;
  hoverText?: string;
  hoverIcon?: IconName;
  innerRef?: any;
  className?: string;
  detailsClassName?: string;
  rightElement?: ReactNode | ReactNode[];
  showGrabber?: boolean;
  'data-testid'?: string;
}

export const Item: React.FC<ItemProps> = ({
  children,
  hoverText,
  hoverIcon,
  onClick,
  showGrabber = true,
  className = '',
  detailsClassName = '',
  rightElement,
  innerRef,
  ...rest
}) => {
  const Element = onClick ? 'a' : 'div';

  return (
    <div
      className={`${styles.root} ${className}`}
      {...rest}
      data-testid={rest['data-testid'] || 'card-item'}
      ref={innerRef}
    >
      <Element
        className={`${styles.container} ${styles.hoverContainer} ${(showGrabber === false && styles.hideGrabber) ||
          ''}`}
        onClick={onClick}
      >
        {showGrabber && (
          <div className={styles.grabber}>
            <Grabber />
          </div>
        )}

        <div className={`${styles.details} ${detailsClassName}`}>{children}</div>

        {(hoverText && hoverIcon && (
          <>
            <div className={styles.hoverText}>{hoverText}</div>
            <div className={styles.hoverIcon}>
              <Icon data-testid="icon" name={hoverIcon} size="md" className={styles.icon} />
            </div>
          </>
        )) ||
          (rightElement && rightElement)}
      </Element>
    </div>
  );
};
